export default __webpack_public_path__ + "static/media/WorkwearLaundry.3c2c45cf.png";